import { Form, Select, Tooltip } from 'antd';
import React, { useEffect } from 'react';
import { InfoCircleOutlined } from '@ant-design/icons';

interface CnAdministratorAccessProps {
    orgaId: string;
    administratorAccessValue: string;
    onChange: (value: string) => void;
}

interface Collaborator {
    coll_id: string;
    name: string;
}

export default function CnAdministratorAccess(props: CnAdministratorAccessProps) {

    const { orgaId, onChange, administratorAccessValue } = props;

    const [collaboratorsRg3or2, setCollaboratorsRg3or2] = React.useState<Collaborator[]>([]);
    const [administratorCollSelected, setAdministratorCollSelected] = React.useState<string>(administratorAccessValue);

    useEffect(() => {
        _getCollaboratorsRg3Or2()
    }, []);

    const _getCollaboratorsRg3Or2 = async () => {
        try {
            const response = await fetch(`/organisations/${orgaId}/collaborators/rg3or2`);
            const collaboratorsData: Collaborator[] = await response.json();
            setCollaboratorsRg3or2(collaboratorsData);
        } catch (error) {
            console.error('Error fetching collaborators:', error);
        }
    };

    return (
        <Form.Item
            label={
                <>
                    Profil administrateur
                    <Tooltip title="Si un utilisateur est sélectionné, il pourra accéder à l'onglet de paramétrage du logiciel (gestion des colonnes dynamiques) et en modifier les réglages.">
                        <InfoCircleOutlined style={{ marginLeft: 6, color: 'rgba(0,0,0,0.45)' }} />
                    </Tooltip>
                </>
            }
            className="no-box-shadow"
            style={{ 
                marginBottom: 8
             }}
        >
            <Select
                placeholder="Sélectionner un utilisateur"
                showSearch
                allowClear
                value={administratorCollSelected || undefined}
                options={collaboratorsRg3or2.map((collaborator) => ({
                    value: collaborator.coll_id,
                    label: collaborator.name,
                }))}
                onChange={(value: string) => {
                    const selected = value ?? '';
                    setAdministratorCollSelected(selected);
                    onChange(selected);
                }}
                onClear={() => {
                    setAdministratorCollSelected('');
                    onChange('');
                }}
                filterOption={(input, option) =>
                    option != undefined && option.label.toLowerCase().includes(input.toLowerCase())
                }
            />
        </Form.Item>
    );
};
